"use client";

import type { JobPosting } from "~care/types/job";

import { fetchWithClientOrigin } from "@homeinstead/shared/api";
import { useQuery } from "@tanstack/react-query";

interface LocationCareersParams {
  officeNumber: number;
  enabled?: boolean;
}

// Gets the career listings for a given office
const fetchLocationCareers = async ({
  officeNumber,
}: LocationCareersParams): Promise<JobPosting[]> => {
  const searchParams = new URLSearchParams({
    id: officeNumber.toString(),
  });

  const response = await fetchWithClientOrigin(
    `/api/careers?${searchParams.toString()}`,
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const result = await response.json();

  if (!result.ok) {
    throw new Error(result.error || "Error fetching location careers");
  }

  return result.data;
};

export const useLocationCareers = (params: LocationCareersParams) => {
  return useQuery({
    enabled: params.enabled ?? true,
    queryFn: () => fetchLocationCareers(params),
    queryKey: ["locationCareers", params.officeNumber],
  });
};
